import * as React from "react";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import Collapse from "@mui/material/Collapse";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import DocumentList from "./DocumentList";
import { Document } from "../db";
import Chip from "@mui/material/Chip";
import ListItem from "@mui/material/ListItem";
import { DocumentAndOptionalScore } from "../pages/App";

export interface DocumentSubsectionProps {
  docs: DocumentAndOptionalScore[];
  breakdown: string[];
  onFileOpened: (doc: Document, target: string) => void;
  onFileSyncRequested: (docs: Document[]) => void;
  expanded: string[];
  setExpanded: (val: string[]) => unknown;
}

export default function DocumentSubsection(props: DocumentSubsectionProps) {
  // Map each document to its filter value
  const { expanded: expandedPath, setExpanded } = props;
  const firstExpanded = expandedPath[0];

  const docsByGroup: Record<string, Document[]> = {};

  if (!props.breakdown || props.breakdown.length === 0) {
    return <DocumentList docs={props.docs} onFileOpened={props.onFileOpened} />;
  }

  const keyField = props.breakdown[0];

  for (let d of props.docs) {
    const k = (d as any)[keyField];
    if (!docsByGroup[k]) {
      docsByGroup[k] = [];
    }
    docsByGroup[k].push(d);
  }
  // Sort by our key
  const keys = Object.keys(docsByGroup).sort();

  return (
    <List dense>
      {keys.map((val, idx) => {
        const expanded = val === firstExpanded;

        return (
          <div key={val}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => {
                  setExpanded(expanded ? [] : [val]);
                }}
              >
                <ListItemAvatar sx={{ minWidth: "auto" }}>{expanded ? <ExpandMore /> : <ChevronRightIcon />}</ListItemAvatar>
                <ListItemText
                  primary={
                    <Box>
                      {val} <Chip variant="outlined" label={docsByGroup[val].length} size="small" />
                    </Box>
                  }
                />
              </ListItemButton>
            </ListItem>

            <Collapse in={expanded} timeout={300} unmountOnExit>
              <Box sx={{ pl: 2 }}>
                {props.breakdown.length === 1 ? (
                  <DocumentList docs={docsByGroup[val]} onFileOpened={props.onFileOpened} />
                ) : (
                  <DocumentSubsection
                    onFileSyncRequested={props.onFileSyncRequested}
                    onFileOpened={props.onFileOpened}
                    docs={docsByGroup[val]}
                    breakdown={props.breakdown.slice(1)}
                    expanded={expandedPath.slice(1)}
                    setExpanded={(val) => setExpanded([firstExpanded, ...val])}
                  />
                )}
              </Box>
            </Collapse>
          </div>
        );
      })}
    </List>
  );
}
